// components/FeatureRenderer/DimensionInput.jsx
import React, { useEffect } from 'react';

const DimensionInput = ({ feature, value = {}, onChange }) => {
    // Initialize with defaults if value is empty
    useEffect(() => {
        // Check if value is empty object or missing required fields
        const hasRequiredFields = feature.uiConfig.fields.every(field =>
            field === 'unit' || value[field] !== undefined
        );

        if (!hasRequiredFields && feature.default) {
            onChange(feature.default);
        }
    }, []);

    const handleDimensionChange = (field, fieldValue) => {
        onChange({
            ...value,
            [field]: fieldValue
        });
    };

    return (
        <div className="mb-4">
            <label className="form-label fw-medium">
                {feature.name} {feature.required && <span className="text-danger">*</span>}
            </label>
            <div className="row g-2">
                {feature.uiConfig.fields.map(field => {
                    if (field === 'unit') {
                        return (
                            <div className="col-md-3" key={field}>
                                <select
                                    className="form-select"
                                    value={value.unit || feature.uiConfig.defaultUnit || 'cm'}
                                    onChange={(e) => handleDimensionChange('unit', e.target.value)}
                                >
                                    <option value="cm">cm</option>
                                    <option value="inches">inches</option>
                                </select>
                            </div>
                        );
                    }
                    return (
                        <div className="col-md-4" key={field}>
                            <input
                                type="number"
                                className="form-control"
                                placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                                value={value[field] !== undefined ? value[field] : ''}
                                onChange={(e) => handleDimensionChange(field, parseFloat(e.target.value) || 0)}
                                min="0"
                                step="1"
                            />
                        </div>
                    );
                })}
            </div>
            {feature.description && (
                <small className="text-muted d-block mt-1">{feature.description}</small>
            )}
        </div>
    );
};

export default DimensionInput;